import type { MessageType } from "@expert/shared-types";

import { Flex } from "@mantine/core";
import { useMergedRef } from "@mantine/hooks";

import type { BubbleStyle } from "../../config/types";

import classes from "./MessageBubble.module.css";

const bubbleStyleClassMap: Record<BubbleStyle, string> = {
    reactive: classes.reactiveBubble,
    proactive: classes.proactiveBubble,
    aiGenerated: classes.aiGeneratedBubble,
    expert: classes.expertBubble,
    smartOffer: classes.smartOfferBubble,
    smartOfferGeneric: classes.smartOfferGenericBubble,
    smartOfferResponse: classes.smartOfferResponseBubble,
};

interface MessageBubbleSimplifiedProps {
    type: MessageType;
    bubbleStyle: BubbleStyle;
    dataVariant: "proactive" | "reactive";
    overflowRef: React.RefObject<HTMLDivElement | null>;
    messageIntersectionRef: (node: HTMLDivElement | null) => void;
    children: React.ReactNode;
}

export function MessageBubbleSimplified({
    type,
    bubbleStyle,
    dataVariant,
    overflowRef,
    messageIntersectionRef,
    children,
}: MessageBubbleSimplifiedProps) {
    const mergedRef = useMergedRef(overflowRef, messageIntersectionRef);
    const bubbleClass = bubbleStyleClassMap[bubbleStyle];

    return (
        <Flex
            className={
                type === "SessionSummary"
                    ? `fs-mask ${classes.bubble} ${bubbleClass}`
                    : `${classes.bubble} ${bubbleClass}`
            }
            data-testid={`message-bubble-${type}`}
            ref={mergedRef}
            direction="column"
            data-variant={dataVariant}
        >
            {children}
        </Flex>
    );
}
